import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import PaymentService from "../../services/PaymentService/PaymentService";
import { Spinner } from "react-bootstrap";
import { useNavigate } from "react-router";

function ReturnCheckoutPage() {
  const [status, setStatus] = useState(null);
  const [isVerifying, setIsVerifying] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();//NEW

  useEffect(() => {
    const verifyPayment = async () => {
      try {
        const urlParams = new URLSearchParams(location.search);
        const sessionId = urlParams.get("session_id");

        if (!sessionId) {
          throw new Error('Session ID mancante nella URL');
        }

        const verifyResponse = await PaymentService.verifyPayment(sessionId);
        
        if (verifyResponse.success) {
          setStatus(verifyResponse.status);
        } else {
          throw new Error(verifyResponse.message || 'Verifica del pagamento fallita');
        }
      } catch (error) {
        console.error('Errore durante la verifica del pagamento:', error);
        setStatus('error');
      } finally {
        setIsVerifying(false);
      }
    };

    verifyPayment();
  }, [location]);

  useEffect(() => {
    if (status === "complete") {
      const timer = setTimeout(() => {
        navigate("/gestione-utenti");
      }, 10000); // 10 secondi
  
      return () => clearTimeout(timer); // pulizia in caso il componente venga smontato prima
    }
  }, [status, navigate]);

  if (isVerifying) {
    return (
      <div className="text-center py-5">
        <Spinner />
        <p className="mt-3">Verifica del pagamento in corso...</p>
      </div>
    );
  }

  if (status === "open") {
    return <Navigate to="/checkout" />;
  }

  if (status === "complete") {
    return (
      <section id="success" className="py-5">
        <div className="container">
          <div className="alert alert-secondary">
            <h4 className="alert-heading">Pagamento completato con successo!</h4>
            <p>
              Grazie per il tuo acquisto! Se hai domande, non esitare a contattarci all'indirizzo{" "}
              <a href="mailto:HighEducational@example.com">he.formazione@gmail.com</a>.
            </p>
          </div>
        </div>
      </section>
    );
  }

  if (status === "error") {
    return (
      <div className="text-center py-5">
        <p className="mt-3">Si è verificato un errore durante la verifica del pagamento</p>
      </div>
    );
  }

  return null;
}

export default ReturnCheckoutPage;
